import { Config, CognitoIdentityCredentials } from "aws-sdk";
import {
  CognitoUserPool,
  AuthenticationDetails,
  CognitoUser,
} from "amazon-cognito-identity-js";

Config.region = process.env.REACT_APP_AWS_REGION;
Config.credentials = new CognitoIdentityCredentials({
  IdentityPoolId: process.env.REACT_APP_AWS_IDENTITY_POOL_ID
});

const authenticationDetail = (username, password) => {
  return new AuthenticationDetails({
    Username: username,
    Password: password,
  });
}

const userPool = () => {
  return new CognitoUserPool({
    UserPoolId: process.env.REACT_APP_AWS_USER_POOL_ID,
    ClientId: process.env.REACT_APP_AWS_USER_CLIENT_ID,
  });
};

const cognitoUser = (username) => {
  return new CognitoUser({
    Username: username,
    Pool: userPool(),
  });
};

const cognitoIdpURL = 'cognito-idp.' + process.env.REACT_APP_AWS_REGION
  + '.amazonaws.com/' + process.env.REACT_APP_AWS_USER_POOL_ID;

const institutionPool = new CognitoUserPool({
  UserPoolId: process.env.REACT_APP_AWS_INSTITUTION_POOL_ID,
  ClientId: process.env.REACT_APP_AWS_INSTITUTION_CLIENT_ID,
});

export {
  Config,
  userPool,
  cognitoUser,
  authenticationDetail,
  cognitoIdpURL,
  institutionPool,
}




// WEBPACK FOOTER //
// ./src/constants/AWS.js